import styled from "styled-components";
import { theme } from "@src/theme";

export const CloseButton = styled.button`
  background-color: ${theme.colors.gray300};
  color: ${theme.colors.yellow};
  border: 1px solid ${theme.colors.yellow};
  width: 30px;
  height: 30px;
  border-radius: 15px;
  cursor: pointer;
`;

export const FloatingDismissButton = styled.button`
  background-color: ${theme.colors.yellow};
  color: ${theme.colors.darkBg};
  border: 1px solid ${theme.colors.yellow};
  justify-content: center;
  align-items: center;
  display: flex;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;
